import { useNavigate } from 'react-router-dom';
import * as S from './ModalStyle';

interface ModalProps {
  onClose: () => void;
}

export default function ReserveNoTime({ onClose }: ModalProps) {
  const navigate = useNavigate();
  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalTitle>입장권 예매 불가</S.ModalTitle>
        <S.ModalContent>
          <S.Summary>입장권 예매 가능 시간이 아닙니다.</S.Summary>
          <S.Summary>
            &lt;입장권 예매 시작 시간&gt;
            <p>2025년 4월 19일(토) 오전 10시</p>
          </S.Summary>
        </S.ModalContent>
        <S.CloseButton
          type="button"
          onClick={() => {
            onClose();
            navigate('/');
          }}
        >
          확인
        </S.CloseButton>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
}
